<template>
  <v-autocomplete
    :items="component.options || []"
    item-text="text"
    item-value="value"
    clearable
    v-model="selectedValue"
    @input="emitValue"
    :label="component.label"
    :filter="filter"
  >
  </v-autocomplete>
</template>

<script>
export default {
  props: {
    component: {
      type: Object,
      default: null
    },
    value: {
      type: String,
      default: undefined
    },
    diagnosis: {
      type: Object
    }
  },
  data() {
    return { selectedValue: this.value }
  },
  methods: {
    emitValue() {
      if (this.selectedValue) {
        this.$emit('input', this.selectedValue)
      }
    },
    filter(item, queryText, itemText) {
      const normalizedDescription = itemText
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
      const normalizedQueryText = queryText
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
      return (
        item.value.toLowerCase().includes(normalizedQueryText) ||
        normalizedDescription.includes(normalizedQueryText)
      )
    }
  },
  watch: {
    diagnosis: {
      handler() {
        this.selectedValue = this.diagnosis.organSystemId
        this.$emit('input', this.diagnosis.organSystemId)
      },
      deep: true
    }
  }
}
</script>
